import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from './source.css';

const Source = ({
  Name,
  City,
  Phone,
  Email,
  Website1,
  Website2,
  Description,
  Category,
}) => {
  return (
    <Wrapper>
      <div>
        <div className="org">{Name}</div>
        {City && (
          <div className="city">
            {City} - <span>{Category}</span>
          </div>
        )}
      </div>
      <div className="contacts">
        {Phone && (
          <a href={`tel:${Phone}`}>
            <svg
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <defs>
                <path
                  id="phone-a"
                  d="M17.7277606,2.46792748 L14.3423439,1.68677514 C13.9740496,1.60178165 13.5975848,1.79263452 13.4485939,2.14025821 L11.8860939,5.78599389 C11.7489816,6.10592919 11.8400669,6.47798227 12.1094663,6.69839623 L14.0826759,8.31284936 C12.9116799,10.8087803 10.8620379,12.8866775 8.31285173,14.082641 L6.6983986,12.1094639 C6.47798464,11.8400645 6.10593156,11.7489793 5.78599626,11.8860915 L2.14026058,13.4485915 C1.79273454,13.5975173 1.60175147,13.9739496 1.68677751,14.3423415 L2.46792985,17.7277582 C2.54911475,18.0795486 2.86288428,18.3333246 3.22916032,18.3333246 C11.5653257,18.3333246 18.333327,11.5777257 18.333327,3.22915795 C18.333327,2.86535587 18.0822202,2.54969832 17.7277606,2.46792748 Z"
                />
              </defs>
              <g fill="none" fillRule="evenodd" transform="translate(-1 -1)">
                <mask id="phone-b" fill="#fff">
                  <use xlinkHref="#phone-a" />
                </mask>
                <use fill="#000" fillRule="nonzero" xlinkHref="#phone-a" />
                <g fill="#000" mask="url(#phone-b)">
                  <rect width="20" height="20" />
                </g>
              </g>
            </svg>
            {Phone}
          </a>
        )}
        {Website1 && (
          <a
            href={Website1}
            title={Name}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="18"
              height="16"
              viewBox="0 0 18 16"
            >
              <defs>
                <path
                  id="globe-a"
                  d="M13.52264,7.91666667 L17.8009603,7.91666667 C17.9780111,8.58134766 18.0729004,9.27955729 18.0729004,10 C18.0729004,10.7204427 17.9780111,11.4186523 17.8009603,12.0833333 L13.52264,12.0833333 C13.6904134,10.6819987 13.6834147,9.25957031 13.52264,7.91666667 Z M7.69578451,13.125 C8.04337565,14.8723958 8.77563477,16.7875651 9.97849935,18.0726562 C9.98569336,18.0726888 9.99282227,18.0729167 10.0000163,18.0729167 C10.0072103,18.0729167 10.0143392,18.0726562 10.0215332,18.0726562 C11.2263509,16.7854492 11.9573079,14.8690755 12.304248,13.125 L7.69578451,13.125 Z M13.3640788,6.875 L17.4456217,6.875 C16.4063314,4.40182292 14.1708496,2.5555013 11.4632324,2.05973307 C12.4475423,3.46337891 13.0524577,5.19554036 13.3640788,6.875 Z M12.4737793,7.91666667 L7.52625326,7.91666667 C7.35245768,9.28105469 7.35226237,10.7173503 7.52625326,12.0833333 L12.4738118,12.0833333 C12.6476074,10.7189128 12.6478027,9.28264974 12.4737793,7.91666667 L12.4737793,7.91666667 Z M6.63595378,13.125 L2.55441081,13.125 C3.59366862,15.5981771 5.82915039,17.4444987 8.53676758,17.9402669 C7.55219727,16.5361003 6.94747721,14.8038737 6.63595378,13.125 Z M13.3640788,13.125 C13.0523926,14.8048503 12.4473145,16.5369141 11.4632324,17.9402669 C14.1708496,17.4444987 16.4063314,15.5981771 17.4455892,13.125 L13.3640788,13.125 Z M12.304248,6.875 C11.9566569,5.12760417 11.2243652,3.2124349 10.0215332,1.92734375 C10.0143392,1.92734375 10.0072103,1.92708333 10.0000163,1.92708333 C9.99282227,1.92708333 9.98569336,1.92734375 9.97849935,1.92734375 C8.77368164,3.21455078 8.04272461,5.13092448 7.69578451,6.875 L12.304248,6.875 Z M2.19907227,7.91666667 C2.02198893,8.58134766 1.92709961,9.27955729 1.92709961,10 C1.92709961,10.7204427 2.02198893,11.4186523 2.19907227,12.0833333 L6.47739258,12.0833333 C6.31661784,10.7404297 6.30961914,9.3180013 6.47739258,7.91666667 L2.19907227,7.91666667 Z M6.63595378,6.875 C6.94763997,5.1952474 7.55265299,3.46321615 8.53680013,2.05973307 C5.82918294,2.5555013 3.59370117,4.40182292 2.55441081,6.875 L6.63595378,6.875 Z"
                />
              </defs>
              <g fill="none" fillRule="evenodd" transform="translate(-1 -2)">
                <mask id="globe-b" fill="#fff">
                  <use xlinkHref="#globe-a" />
                </mask>
                <use fill="#000" fillRule="nonzero" xlinkHref="#globe-a" />
                <g fill="#000" mask="url(#globe-b)">
                  <rect width="20" height="20" />
                </g>
              </g>
            </svg>
            {typeof window !== 'undefined' &&
              window.URL &&
              new URL(Website1).host}
          </a>
        )}

        {Website2 && (
          <a
            href={Website2}
            title={Name}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="18"
              height="16"
              viewBox="0 0 18 16"
            >
              <defs>
                <path
                  id="globe-a"
                  d="M13.52264,7.91666667 L17.8009603,7.91666667 C17.9780111,8.58134766 18.0729004,9.27955729 18.0729004,10 C18.0729004,10.7204427 17.9780111,11.4186523 17.8009603,12.0833333 L13.52264,12.0833333 C13.6904134,10.6819987 13.6834147,9.25957031 13.52264,7.91666667 Z M7.69578451,13.125 C8.04337565,14.8723958 8.77563477,16.7875651 9.97849935,18.0726562 C9.98569336,18.0726888 9.99282227,18.0729167 10.0000163,18.0729167 C10.0072103,18.0729167 10.0143392,18.0726562 10.0215332,18.0726562 C11.2263509,16.7854492 11.9573079,14.8690755 12.304248,13.125 L7.69578451,13.125 Z M13.3640788,6.875 L17.4456217,6.875 C16.4063314,4.40182292 14.1708496,2.5555013 11.4632324,2.05973307 C12.4475423,3.46337891 13.0524577,5.19554036 13.3640788,6.875 Z M12.4737793,7.91666667 L7.52625326,7.91666667 C7.35245768,9.28105469 7.35226237,10.7173503 7.52625326,12.0833333 L12.4738118,12.0833333 C12.6476074,10.7189128 12.6478027,9.28264974 12.4737793,7.91666667 L12.4737793,7.91666667 Z M6.63595378,13.125 L2.55441081,13.125 C3.59366862,15.5981771 5.82915039,17.4444987 8.53676758,17.9402669 C7.55219727,16.5361003 6.94747721,14.8038737 6.63595378,13.125 Z M13.3640788,13.125 C13.0523926,14.8048503 12.4473145,16.5369141 11.4632324,17.9402669 C14.1708496,17.4444987 16.4063314,15.5981771 17.4455892,13.125 L13.3640788,13.125 Z M12.304248,6.875 C11.9566569,5.12760417 11.2243652,3.2124349 10.0215332,1.92734375 C10.0143392,1.92734375 10.0072103,1.92708333 10.0000163,1.92708333 C9.99282227,1.92708333 9.98569336,1.92734375 9.97849935,1.92734375 C8.77368164,3.21455078 8.04272461,5.13092448 7.69578451,6.875 L12.304248,6.875 Z M2.19907227,7.91666667 C2.02198893,8.58134766 1.92709961,9.27955729 1.92709961,10 C1.92709961,10.7204427 2.02198893,11.4186523 2.19907227,12.0833333 L6.47739258,12.0833333 C6.31661784,10.7404297 6.30961914,9.3180013 6.47739258,7.91666667 L2.19907227,7.91666667 Z M6.63595378,6.875 C6.94763997,5.1952474 7.55265299,3.46321615 8.53680013,2.05973307 C5.82918294,2.5555013 3.59370117,4.40182292 2.55441081,6.875 L6.63595378,6.875 Z"
                />
              </defs>
              <g fill="none" fillRule="evenodd" transform="translate(-1 -2)">
                <mask id="globe-b" fill="#fff">
                  <use xlinkHref="#globe-a" />
                </mask>
                <use fill="#000" fillRule="nonzero" xlinkHref="#globe-a" />
                <g fill="#000" mask="url(#globe-b)">
                  <rect width="20" height="20" />
                </g>
              </g>
            </svg>
            {typeof window !== 'undefined' &&
              window.URL &&
              new URL(Website2).host}
          </a>
        )}

        {Email && (
          <a href={`mailto:${Email}`}>
            <svg
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="16"
              height="12"
              viewBox="0 0 16 12"
            >
              <defs>
                <path
                  id="envelope-a"
                  d="M15.09375,3.375 L2.90625,3.375 C2.12958984,3.375 1.5,4.00458984 1.5,4.78125 L1.5,13.21875 C1.5,13.9954102 2.12958984,14.625 2.90625,14.625 L15.09375,14.625 C15.8704102,14.625 16.5,13.9954102 16.5,13.21875 L16.5,4.78125 C16.5,4.00458984 15.8704102,3.375 15.09375,3.375 Z M15.09375,4.78125 L15.09375,5.97670898 C14.4368555,6.51164063 13.3896094,7.3434375 11.1507715,9.0965332 C10.6573828,9.48462891 9.68003906,10.417002 9,10.4061328 C8.32007813,10.4171191 7.34241211,9.48448242 6.84922852,9.0965332 C4.61074219,7.34370117 3.56323242,6.51172852 2.90625,5.97670898 L2.90625,4.78125 L15.09375,4.78125 Z M2.90625,13.21875 L2.90625,7.78119141 C3.57755859,8.31588867 4.52956055,9.06621094 5.98060547,10.2024609 C6.62094727,10.7065137 7.74234375,11.8192383 9,11.8124707 C10.2514746,11.8192383 11.3586621,10.7226562 12.0191309,10.2026953 C13.4701465,9.06647461 14.4224121,8.31594727 15.09375,7.78119141 L15.09375,13.21875 L2.90625,13.21875 Z"
                />
              </defs>
              <g fill="none" fillRule="evenodd" transform="translate(-1 -3)">
                <mask id="envelope-b" fill="#fff">
                  <use xlinkHref="#envelope-a" />
                </mask>
                <use fill="#000" fillRule="nonzero" xlinkHref="#envelope-a" />
                <g fill="#000" mask="url(#envelope-b)">
                  <rect width="18" height="18" />
                </g>
              </g>
            </svg>{' '}
            {Email}
          </a>
        )}
      </div>
      <div className="copy">
        <p>{Description}</p>
      </div>
    </Wrapper>
  );
};

Source.propTypes = {
  Name: PropTypes.string,
  City: PropTypes.string,
  Phone: PropTypes.string,
  Website1: PropTypes.string,
  Website2: PropTypes.string,
  Email: PropTypes.string,
  Description: PropTypes.string,
  Category: PropTypes.string,
};

export default Source;
